import { BadgePostionLiterals, BadgeSizeLiterals } from './Badge.types';

export const BADGE_POSITION_MAP: Record<BadgePostionLiterals, string> = {
  'top-right': 'top-[-5px] right-0',
  'top-center': 'top-[-5px] left-[-5px]',
  'top-left': 'top-[-5px] left-0',
  'bottom-right': 'bottom-[-5px] right-0',
  'bottom-left': 'bottom-[-5px] left-0',
};

export const BADGE_SIZE_MAP: Record<BadgeSizeLiterals, string> = {
  lg: '!w-[20px] !h-[20px]',
  md: '!w-[15px] !h-[15px]',
  sm: '!w-[10px] !h-[10px]',
};
